import type { ComponentType, SVGProps } from 'react';
import { Bot, Trophy } from 'lucide-react';

import { ChessBotPanel } from '@/components/chess/ChessBotPanel';
import { ChessTournamentsPanel } from '@/components/hub/panels/ChessTournamentsPanel';
import { env } from '@/env';

/**
 * LE SCHEDE DEGLI SCACCHI SU LIMULO nella Hub (E6 di ADR-0193, P3) — montate da `HubSections` quando il gioco attivo e' gli
 * scacchi E `chessLimuloAcceso()` E il ruolo `beta` (come il backgammon: `showQgammon`).
 *
 * «Tornei» (i tornei di scacchi del catalogo Limulo, `ChessTournamentsPanel`) e, dietro il flag del bot, «Bot» (E7: la tessera
 * «Gioca contro il bot», `ChessBotPanel`, che porta a `/chess/bot`). Le altre arrivano ciascuna con
 * la sua PR del piano (fase 1 di tma-orcb-52): il tavolo (P4), il Live (P5). ⚠️ Come per il backgammon, l'elenco SOSTITUISCE la
 * riga cross-game (Eventi / Classifiche / Live del monolite), che per un gioco sintetico sarebbe vuota.
 * Il ruolo e il flag non si ricontrollano qui: li chiede chi monta (`showChess` in `HubSections`).
 */
export type ChessSectionKey = 'tournaments' | 'bot';

export interface ChessSectionDef {
  key: ChessSectionKey;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  Panel: ComponentType;
  ownScroll: boolean;
}

export function chessSectionDefs(t: (key: string, options: { defaultValue: string }) => string): ChessSectionDef[] {
  // 🔴 SENZA IL FLAG LA TESSERA NON ESISTE NE' NELL'ELENCO NE' NEL BUNDLE DI PRODUZIONE. Le DUE letture servono entrambe, come per la
  // riga di diagnosi: il confronto LETTERALE e' quello che il bundler piega (in produzione la condizione e' `false` e il pannello,
  // con il suo marcatore `data-bot-tessera`, esce dalla build); `env.featureChessBotEnabled` e' quello che i test accendono.
  const conBot = import.meta.env.VITE_FEATURE_CHESS_BOT_ENABLED === 'true' && env.featureChessBotEnabled;
  return [
    {
      key: 'tournaments',
      Icon: Trophy,
      label: t('sections.tournaments', { defaultValue: 'Tournaments' }),
      Panel: ChessTournamentsPanel,
      ownScroll: true,
    },
    ...(conBot
      ? [
          {
            key: 'bot' as const,
            Icon: Bot,
            label: t('sections.chessBot', { defaultValue: 'Bot' }),
            Panel: ChessBotPanel,
            ownScroll: true,
          },
        ]
      : []),
  ];
}
